import React, { useState } from 'react';
import { toast } from 'react-toastify';
import GenericModal from '../../../components/modal/GenericModal';
import InputText from '../../../components/modalComponents/InputText';
import { usePostRequest } from '../../../hooks/usePostRequest/usePostRequest';
import { responseCode200, mostrarMensajeDeErrorConToast } from '../../../consumers/httpRequiestsUtils';
import { completarEntrevistaAPI } from '../../../consumers/backendApisUrls';
import { formatearFecha } from '../misTrasladosYPromociones/shared';

const ESTADO_APTO = 63;
const ESTADO_NOAPTO = 64;

// ──────────────────────────────────────────────────────────────────────────
// "Completar entrevista" (30/09/2026, a pedido de Jody): el evaluador
// (entrevistador asignado) califica SU entrevista puntual como Apto/No apto,
// con un comentario. Se abre desde "Entrevistas por completar" en Mis
// Traslados y Promociones (EntrevistasPorEvaluar.jsx), sobre una fila de
// GetEntrevistasPorEvaluar — que ya trae todos los datos de cabecera, así que
// a diferencia de EntrevistaPostulante.jsx (GDH) este modal NO necesita pedir
// GetDetalleForEntrevista.
//
// Deliberadamente un componente nuevo, no una extensión de
// EntrevistaPostulante.jsx: ese modal es de GDH sobre TODAS las entrevistas de
// un postulante, y reutilizarlo aquí hubiera requerido filtrar fila por fila
// si el entrevistador logueado puede calificar cada una. Acá el propio listado
// de "Entrevistas por completar" ya viene filtrado server-side a las
// entrevistas del entrevistador logueado, así que ese problema no existe.
//
// Actualiza solo TP_EntrevistaDetalle (ver CompletarEntrevistaRequest.java) —
// no toca TP_Entrevista.IdEstadoGdhFinal ni TP_Postulante.
// ──────────────────────────────────────────────────────────────────────────

const CompletarEntrevistaModal = ({ toggleModal, refreshPage, entrevista = {} }) => {
    const [executePost] = usePostRequest();
    const [resumen, setResumen] = useState('');
    const [enviando, setEnviando] = useState(false);

    const handleCalificar = async (idEstadoEntrevista) => {
        if (!resumen.trim()) {
            toast.error('Debe ingresar un comentario de la entrevista.');
            return;
        }
        if (enviando) return;

        setEnviando(true);
        try {
            const payload = {
                idEntrevistaDetalle: entrevista?.IdEntrevistaDetalle,
                idEstadoEntrevista,
                resumenEntrevista: resumen.trim(),
            };

            const response = await executePost(completarEntrevistaAPI(), payload);
            if (!responseCode200(response)) {
                mostrarMensajeDeErrorConToast(response);
                return;
            }

            toast.success('Entrevista evaluada satisfactoriamente.');
            refreshPage && await refreshPage();
            toggleModal();
        } catch (error) {
            console.error('Error completando la entrevista', error);
            toast.error('No se pudo calificar la entrevista.');
        } finally {
            setEnviando(false);
        }
    };

    return (
        <GenericModal showModal={toggleModal} titulo="Completar entrevista" width="600px">
            <div className="modal-body pt-3">
                <div className="row">
                    <div className="col-sm-6"><InputText label="Colaborador" name="colaborador" value={entrevista?.NombrePostulante} direction="column" isDisabled /></div>
                    <div className="col-sm-6"><InputText label="Convocatoria" name="convocatoria" value={entrevista?.NombreConvocatoria} direction="column" isDisabled /></div>
                </div>
                <div className="row mt-2">
                    <div className="col-sm-4"><InputText label="Cargo" name="cargo" value={entrevista?.CargoPostulante} direction="column" isDisabled /></div>
                    <div className="col-sm-4"><InputText label="Sede" name="sede" value={entrevista?.SedePostulante} direction="column" isDisabled /></div>
                    <div className="col-sm-4"><InputText label="Fecha / Hora" name="fechaHora" value={formatearFecha(entrevista?.FechaHora)} direction="column" isDisabled /></div>
                </div>

                <hr />

                <div className="form-group">
                    <label className="modal-label mb-0 required">Comentario de la entrevista</label>
                    <textarea className="form-control" rows={5} disabled={enviando}
                        value={resumen}
                        onChange={(e) => setResumen(e.target.value)}
                        placeholder="Ingresar el resumen / comentario de la entrevista" />
                </div>

                <div className="d-flex justify-content-center mt-3">
                    <button type="button" className="btn generic-button-buscador generic-button-hover-rojo mr-2"
                        disabled={enviando} onClick={() => handleCalificar(ESTADO_NOAPTO)}>
                        {enviando ? 'Guardando...' : 'No apto'}
                    </button>
                    <button type="button" className="btn generic-button-buscador"
                        disabled={enviando} onClick={() => handleCalificar(ESTADO_APTO)}>
                        {enviando ? 'Guardando...' : 'Apto'}
                    </button>
                </div>
            </div>
        </GenericModal>
    );
};

export default CompletarEntrevistaModal;
